export const mutations = {
    setPedidoCompra(state, data) {
        state.pedidoCompra = data
    },
    setPedidosCompras(state, data) {
        state.pedidosCompras = data
    },
    addPedidoCompra(state, data){
        state.pedidosCompras.push(data)
    },
    removePedidoCompra(state, data){
        let index = state.pedidosCompras.map(x => x.id).indexOf(data.id);
        state.pedidosCompras.splice(index, 1)
    },
    addItemPedidoCompra(state, data){
        state.itensPedidoCompra.push(data)
    },
    setItensPedidoCompra(state, data){
        state.itensPedidoCompra = data
    },
    removeItemPedidoCompra(state, item){
        let indice = state.itensPedidoCompra.indexOf(item)
        state.itensPedidoCompra.splice(indice, 1);
    },
    setModalCadastrarPedidoCompra(state, status) {
        state.modalCadastrarPedidoCompra = status
    },
    setModalExcluirPedidoCompra(state, status) {
        state.modalExcluirPedidoCompra = status
    },
    setModalPesquisarPedidoCompra(state, status) {
        state.modalPesquisarPedidoCompra = status
    },
    setModalEnviarEmailPedidoCompra(state, status) {
        state.modalEnviarEmailPedidoCompra = status
    }
}

export default {}